import React from "react";

const Label = ({ children, ...props }) => {
    return (
        <label className="tw-text-sm tw-text-gray-600 tw-mb-1 tw-font-sans" {...props}>
            {children}
        </label>
    );
}

export default Label;
